import api from './api';
import { BoreSize, CreateBoreSizeData, UpdateBoreSizeData } from '../types/boreSize';

export interface BoreSizeListResponse {
  success: boolean;
  data: BoreSize[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface BoreSizeResponse {
  success: boolean;
  data: BoreSize;
  message?: string;
}

export const boreSizeService = {
  async getBoreSizes(params?: {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }): Promise<BoreSizeListResponse> {
    const response = await api.get('/bore-sizes', { params });
    return response.data;
  },

  async getBoreSizeById(id: number): Promise<BoreSizeResponse> {
    const response = await api.get(`/bore-sizes/${id}`);
    return response.data;
  },

  async createBoreSize(data: CreateBoreSizeData): Promise<BoreSizeResponse> {
    const response = await api.post('/bore-sizes', data);
    return response.data;
  },

  async updateBoreSize(id: number, data: UpdateBoreSizeData): Promise<BoreSizeResponse> {
    const response = await api.put(`/bore-sizes/${id}`, data);
    return response.data;
  },

  async deleteBoreSize(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/bore-sizes/${id}`);
    return response.data;
  }
};